<template>
  <div class="main__light_green rounded-lg">
    <div
      class="width-100 flex flex-between"
      no-gutters>
      <div class="h9-text-medium pl-7 py-4 mb-2">
        {{ title }}
      </div>
      <div class="mr-5 my-auto">
        <sButton
          icon="arrow"
          :icon-class="show ? 's-svg-icon-rotate-180' : ''"
          icon-size="12px"
          small
          type="text"
          @click="roll">
          {{ show ? $t('Common.RollUp') : $t('Common.Expand') }}
        </sButton>
      </div>
    </div>
    <div
      v-if="show"
      class="width-100 all-chart-wrapper flex px-7 pb-5"
      :class="wrapper_class">
      <slot name="chart"/>
    </div>
  </div>
</template>
<script>

export default {
  name: 'chartCard',
  data() {
    return {
      loading: true,
      show: true
    }
  },
  props: {
    title: String,
    wrapper_class: String
  },
  methods: {
    roll() {
      this.show = !this.show
      this.$nextTick(() => {
        this.$forceUpdate()
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.div-x {
  position: relative;
  &:first-child {
    border-left: 1px solid var(--black-color);
  }
  &:last-child {
    border-right: 1px solid var(--black-color);
  }
}
.horizontal-div-x{
  position: relative;
}
.div-y {
  border-left: 1px solid var(--v-main__green-base);
  border-bottom: 1px solid var(--v-main__green-base);
  &:last-child {
    border-bottom: 1px solid var(--black-color);
  }
}

.div-y, .vertical-div-y {
  height: 40px;
  position: relative;
}

.chart, .wrapper {
  width: 100%;
  position: relative;
}
.graph{
  position: absolute;
  z-index: 100;
  .value {
    cursor: pointer;
  }

  .connector {
    position: absolute;
    //bottom: 5px;
    left: 2px;

  }
  //left: -4px
}
.step {
  position: absolute;
  &.y {
    border-bottom: 1px solid var(--black-color);
    width: 8px;
    height: 0px;
    right: -16px;
    top: 11px;
    /*
    &:first-child {
    }
    bottom: 8px;
    left: calc(50% - 7.45px/2 - 544.01px);
    top: 228px;
    */

  }
  &.x{
    border-left: 1px solid var(--black-color);
    width: 0px;
    height: 8px;
    // bottom: -8px;
    left: 0px;
    /*
    left: calc(50% - 0px/2 - 457.83px);
    top: 428px;
    */

  }
}

</style>
